/* eslint-disable no-bitwise */
/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import { getMessaging, getToken, onMessage, isSupported } from 'firebase/messaging';
import { DataCollectorService } from '../data_collector_services/data_collector_service.service';
import { LocalStorageService } from '../localstorage.service';
import { TokenService } from '../token/token.service';
import { UtilityService } from '../utility_functions/utility_functions.service';

@Injectable({
  providedIn: 'root'
})
export class FirebaseService {

  constructor(
    private _localStorageService: LocalStorageService,
    private _dataCollectorService: DataCollectorService,
    private _tokenService: TokenService,
    private _utilityService: UtilityService
  ) { }

  requestPermission(): void {
    //For browsers that support Promise
    try {
      Notification.requestPermission().then((permission) => {
        if (permission === 'granted') {
          if(this._localStorageService.getLocalStorage('auth_token'))
          {
              this.retrieveToken();
          }
          // [END_EXCLUDE]
        } else {
          //  console.log('Unable to get permission to notify.');
        }
      });
    }
    catch(err) {
      //For browsers that don't support Promises, handling it with the help of a callback function
      Notification.requestPermission((permission) => {
        if (permission === 'granted') {
          if(localStorage.getItem('auth_token'))
          {
              this.retrieveToken();
          }
        }
      });
    }
    // [END request_permission]
  }

  retrieveToken(): void{
    const messaging = getMessaging();
        getToken(messaging).then(
            (currentToken) =>{
                if(currentToken){
                  const prevToken = this._localStorageService.getLocalStorage('push_token');
                  if(prevToken !== currentToken){
                      const deviceId = this._uuid4();
                      this._localStorageService.setLocalStorage('device_id', deviceId);
                      const device = {
                        'device_token': currentToken,
                        'device_type': 'WEB',
                        'device_id': deviceId
                      };
                      const baseURl = this._localStorageService.getLocalStorage('dc_api_url');
                      if(!this._utilityService.isEmptyOrUndefined(baseURl)){
                        this._dataCollectorService.postData(this._tokenService?.registerDeviceUrl(),{device:device})
                        .subscribe((res: any)=>{
                            this._setTokenSentToServer(currentToken);
                         });
                      }
                    }
                }else{
                    this._setTokenSentToServer(null);
                }
            }
        )
        .catch((err)=>{
            this._setTokenSentToServer(null);
        });
  }

  private _setTokenSentToServer(sent: null | string): void {
    this._localStorageService.setLocalStorage('push_token', sent);
  }

  private _uuid4(): string {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    }
}
